<template>
    <div class="home-content">
        <EmptyPage :height="588" :loading="loading" v-if="list.length === 0" />
        <div v-else>
            <div class="home-content-list">
                <div class="home-content__item" v-for="(item, index) in list" :key="index">
                    <Card :data="item" @openDetail="openDetail" @openUserDetail="openUserDetail" />
                </div>
            </div>
            <div class="home-content__pagination">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :hide-on-single-page="true"
                    :page-size="pageSize"
                    :current-page="pageNum"
                    :total="total"
                    @current-change="handlePageChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { openWindow } from '@/utils/utils';
import { getRecommendList, getWorkList, getArticleList, getFollowList } from '@/api/home';
import Card from '@/views/components/Card';
import EmptyPage from '@/components/EmptyPage';

export default {
    name: 'CardList',
    components: {
        Card,
        EmptyPage
    },
    inject:['backTop'],
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data: () => ({
        loading: true,
        total: 0,
        pageSize: 30,
        pageNum: 1,
        list: [],
        categoryList: [
            { label: '原创', value: 3 },
            { label: '转载', value: 1 },
            { label: '自译', value: 2 }
        ]
    }),
    computed: {
        ...mapState('user', ['userInfo'])
    },
    watch: {
        type() {
            this.pageNum = 1
            sessionStorage.setItem(this.$route.path, 1)
            this.loading = true;
            this.list = [];
            this.getData();
        }
    },
    mounted() {
        this.pageNum = sessionStorage.getItem(this.$route.path) || 1
        this.getData();
    },
    methods: {
        async getData() {
            // 0 首页推荐
            // 1 推荐作品
            // 2 推荐经验
            // 3 我的关注
            try {
                let res = null;
                let params = {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum
                };
                if (this.type === 0) {
                    res = await getRecommendList(params);
                } else if (this.type === 1) {
                    res = await getWorkList(params);
                } else if (this.type === 2) {
                    res = await getArticleList(params);
                } else if (this.type === 3) {
                    params.id = this.userInfo.id;
                    res = await getFollowList(params);
                }

                const { code, data } = res;
                if (res && code === 0) {
                    this.list = data.result.map(item => {
                        let category = null;
                        this.categoryList.forEach(a => {
                            if (a.value === item.type) {
                                category = a.label;
                                return;
                            }
                        });
                        return {
                            id: item.id,
                            type: item.type,
                            title: item.title,
                            follow: item.viewCount, // 浏览量
                            collect: item.collectionCount, // 点赞量
                            like: item.zanCount, // 收藏量
                            category,
                            image: item.logo,
                            userId: item.user && item.user.id,
                            name: item.user && item.user.name,
                            avatar: item.user && item.user.imageAddress,
                            tp: item.tp
                        };
                    });
                    this.total = data.total;
                }
            } catch (e) {
                throw e;
            } finally {
                this.loading = false;
            }
        },
        handlePageChange(pageNum) {
            this.pageNum = pageNum;
            sessionStorage.setItem(this.$route.path,pageNum)
            this.getData();
            const scrollEl = document.getElementsByClassName('app-layout')[0]
            scrollEl.scrollTo({
                top:document.body.clientWidth> 1620 ? 506 : 400,
                behavior: "smooth"
            })
        },
        openDetail(item) {
            let url = null;
            switch(this.type) {
                case 0:
                    if (item.tp === 1) {
                        url = '/#/experience/detail/';
                    } else if (item.tp === 2) {
                        url = '/#/works/detail/';
                    }
                    break;
                case 1:
                    url = '/#/works/detail/';
                    break;
                case 2:
                    url = '/#/experience/detail/';
                    break;
                case 3:
                    if (item.tp === 1) {
                        url = '/#/experience/detail/';
                    } else if (item.tp === 2) {
                        url = '/#/works/detail/';
                    }
                    break;
                default:
                    break;
            }
            if (url) {
                openWindow(url + item.id);
            }
        },
        openUserDetail(id) {
            if (!id) return;
            this.$router.push({
                name: 'User',
                params: { id }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.home-content {
    width: 1600px;
    overflow: hidden;

    &__item {
        display: inline-block;
        width: 300px;
        margin-right: 25px;
        margin-bottom: 25px;

        &:nth-child(5n + 5) {
            margin-right: 0;
        }
    }
    &__pagination {
        margin-top: 25px;
        text-align: center;
    }
}

// 小屏
@include mq($small) {
    .home-content {
        width: 1200px;

        &__item {
            width: 228px;
            margin-right: 15px;
            margin-bottom: 15px;
        }
    }
}
// 小屏
@include mq($smaller) {
    .home-content {
        width: unset;

        &__item {
            width: 219px;
            margin-right: 15px;
            margin-bottom: 15px;
            &:nth-child(4n + 4) {
                margin-right: 0;
            }
            &:nth-child(5n + 5) {
                margin-right: 15px;
            }
        }
    }
}
</style>
